import { Component, computed, input } from '@angular/core';
import { ToolParam } from '../../../../utils/models/tool.models';
import { timelinePreviewEntries } from './timeline-preview.util';

@Component({
  selector: 'app-timeline-preview',
  templateUrl: './timeline-preview.component.html',
  styleUrls: ['./timeline-preview.component.scss'],
})
export class TimelinePreviewComponent {
  /** Inputs. */
  readonly data = input<Record<string, unknown> | Record<string, unknown>[]>();
  readonly parameters = input<ToolParam[]>([]);

  /** Returns the preview entries for the supplied data. */
  readonly entries = computed(() => timelinePreviewEntries(this.data(), this.parameters()));
}
